export default __webpack_public_path__ + "static/media/ic_glp_40_.087335c1.svg";